// The blank run below a panel's content: the New button / navbar zone at rest,
// or the keyboard while it is up. Rendered as a spacer rather than padding to
// handle mobile keyboard weirdness. Under a mounted bottom editor the composer
// pill owns the panel's foot, so only the phone's own bottom inset remains — or
// its navbar, which a phone keeps under the pill.
import { BOTTOM_EDITOR_NAVIGATION_CLEARANCE_VAR } from './bottomEditor'

export const LEGACY_PANEL_BOTTOM_SPACER_PX = { ios: 130, other: 100 }
// The card column ends with rounded corners under the pill and stands this far
// off the panel's edge on desktop, the way it stands off the top under the
// header chrome; phones use the device inset instead.
export const BOTTOM_EDITOR_DESKTOP_EDGE_GAP_PX = 15

export type PanelBottomSpacerInput = {
    keyboardOpen?: boolean
    keyboardHeight?: number
    // Android, app and browser alike, resizes the viewport for the keyboard itself.
    nativeKeyboardResize?: boolean
    isIOS?: boolean
    isMobile?: boolean
    // What the pill clears at a phone's bottom edge; see resolveBottomEditorInset.
    bottomEditorInset?: string
    // The phone's navbar is showing under the pill, so the foot clears its
    // measured height (BOTTOM_EDITOR_NAVIGATION_CLEARANCE_VAR) as well.
    bottomNavigationVisible?: boolean
}

export type PanelBottomSpacers = {
    legacy: string
    bottomEditor: string
}

export function resolvePanelBottomSpacers({
    keyboardOpen = false,
    keyboardHeight = 0,
    nativeKeyboardResize = false,
    isIOS = false,
    isMobile = false,
    bottomEditorInset = '0px',
    bottomNavigationVisible = false,
}: PanelBottomSpacerInput): PanelBottomSpacers {
    if (keyboardOpen) {
        const base = Number.isFinite(Number(keyboardHeight)) ? Number(keyboardHeight) : 0
        const extra = isIOS ? 5 : 30
        const keyboard = nativeKeyboardResize ? '0px' : `${Math.max(0, base + extra)}px`
        return { legacy: keyboard, bottomEditor: keyboard }
    }

    return {
        legacy: `${
            isIOS ? LEGACY_PANEL_BOTTOM_SPACER_PX.ios : LEGACY_PANEL_BOTTOM_SPACER_PX.other
        }px`,
        bottomEditor: isMobile
            ? bottomNavigationVisible
                ? `max(${bottomEditorInset}, var(${BOTTOM_EDITOR_NAVIGATION_CLEARANCE_VAR}, 0px))`
                : bottomEditorInset
            : `${BOTTOM_EDITOR_DESKTOP_EDGE_GAP_PX}px`,
    }
}
